module.exports = __webpack_public_path__ + "static/media/error-blue.6d33552c.png";